var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('PageHeader',{attrs:{"add":{icon: 'bx bx-add-to-queue bx-tada', title: 'general.new', link: 'setting-company-round-add'},"title":_vm.$t('setting.company.round.text')}}),_c('List',{attrs:{"dataList":_vm.termList,"updating":_vm.fetchingStats,"navigate":_vm.pageNavigate,"formats":[],"fields":[ 
          ("name: " + (_vm.$t('setting.company.round.name'))), 
          ("method: " + (_vm.$t('setting.company.round.method'))), 
          ("ratio: " + (_vm.$t('setting.company.round.ratio'))), 
          ("variance_at: " + (_vm.$t('setting.company.round.variance_at'))) ],"deletes":[_vm.deleted, null],"edit":{link: 'setting-company-round-edit'},"filter":{
          search: ['rounding_rules.name'],
          dropdown: []
        }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }